import {BaseView} from "./core/view"
import { TrackingUtil } from "./utils/tracking"
import { ClassUtil } from "./utils/class-util"
var LazyLoad = require('./utils/lazyload');

export default BaseView.extend({

    el: window,
    stickyAd: document.querySelector(".js-sticky"),
    stickyAdWrapper: document.querySelector(".js-sticky-wrapper"),
    navigation: document.querySelector(".js-navigation"),
    body: document.querySelector('body'),
    toTopButton: document.querySelector(".js-to-top-button"),
    initialLazyLoader: null,

    events: {
        'scroll': 'runScrollScripts',
        'resize': 'onWindowResize'
    },
    
    initialize: function() {
        this.loadImages();
    },

    runScrollScripts: function(e){
        this.onScroll(e);
        this.loadImagesWithBigOffset();
        this.onScrollLoadDoublelick();
        this.onScrollLoadAdSense();
    },
	
	onScrollLoadDoublelick: _.once(function() {
    		if(typeof dataLayer !== 'undefined') {
    			dataLayer.push({
    	 			'event': 'doubleClickOnScroll',
    	 			'gtmDfpScrollTrigger': true
    	 		});
    		}
	}),

    onScrollLoadAdSense: _.once(function() {
        if(typeof dataLayer !== 'undefined') {
            dataLayer.push({
                'event': 'adsenseOnScroll'
            });
        }
    }),
    
    loadImagesWithBigOffset: _.once(function() {
    		// destroy initial loader with small offset
    		if(this.initialLazyLoader) {
    			this.initialLazyLoader.destroy();
    		}
    		// add new loader with big offset so users don't see loading
        new LazyLoad({
            threshold: 3000,
            data_src: 'original'
        });
    }),

    loadImages: function () {
    		// needed for lazy images already in viewport
    		this.initialLazyLoader = new LazyLoad({
            threshold: 50,
            data_src: 'original'
        });
	    	if(this.$el.scrollTop() > 0) {
	    		// use bigger offset if page is already scrolled
	    		this.loadImagesWithBigOffset();
	    	}
    },

    onScroll: _.throttle(function () {
        this.handleToTopButton();
        if(this.stickyAd !== null) {
        		this.handleSticky();
        }
    }, 300),

    handleToTopButton: function () {
        if (this.$el.scrollTop() > 600) {
        		ClassUtil.addClass(this.toTopButton, 'to-top-button--is-active');
        } else {
            ClassUtil.removeClass(this.toTopButton, 'to-top-button--is-active');
        }
    },

    onWindowResize: _.throttle(function(){
        if(this.body) {
            if(window.innerWidth > 567){
                this.body.classList.remove('side-navigation--is-open');
            }
        }
    }, 300),
    
    handleSticky: function() {
		var navigationOffsetHeight = this.navigation.offsetHeight,
		buffer = 10,
		adWrapperOffsetTop = this.stickyAdWrapper.offsetTop,
		adWrapperHeight = this.stickyAdWrapper.offsetHeight,
		windowInnerHeight = window.innerHeight;
		
		if(adWrapperHeight - window.pageYOffset + adWrapperOffsetTop - windowInnerHeight < 0) {
			this.stickyAd.style.position = "absolute";
			this.stickyAd.style.top = "initial";
    			this.stickyAd.style.bottom = "0px";
		} else if(window.pageYOffset + buffer > (adWrapperOffsetTop - navigationOffsetHeight)) {
    			this.stickyAd.style.position = "fixed";
	    		this.stickyAd.style.top = buffer + navigationOffsetHeight + "px";
    		} else {
    			this.stickyAd.style.position = "initial";
    		}
    }

});
